import { render } from "./F2Upload.vue?vue&type=template&id=02181a74&scoped=true&ts=true"
import script from "./F2Upload.vue?vue&type=script&lang=ts"
export * from "./F2Upload.vue?vue&type=script&lang=ts"

import "./F2Upload.vue?vue&type=style&index=0&id=02181a74&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02181a74"]])

export default __exports__